import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  ogType?: string;
  ogImage?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE = "15黑料网";
const BASE = "https://sznita.cn";

export default function Seo({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = "website",
  ogImage,
  jsonLd,
}: SeoProps) {
  const canonical = `${BASE}${canonicalPath}`;
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const existing = document.querySelectorAll("script[data-seo-jsonld]");
    existing.forEach((node) => node.remove());
    if (!jsonLdKey) return;
    const parsed = JSON.parse(jsonLdKey) as Record<string, unknown> | Record<string, unknown>[];
    const list = Array.isArray(parsed) ? parsed : [parsed];
    list.forEach((item) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.text = JSON.stringify(item);
      document.head.appendChild(script);
    });
    return () => {
      document
        .querySelectorAll("script[data-seo-jsonld]")
        .forEach((node) => node.remove());
    };
  }, [jsonLdKey]);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="zh_CN" />
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}
    </>
  );
}